import React, { Component } from "react";
import { Paper } from "material-ui";
import ActionButtons from "../../components/EmailAddressBook/ActionButtons";
import EmailAddressBookTable from "../../components/EmailAddressBook/EmailAddressBookTable";
import AddEmailAddress from "../../components/EmailAddressBook/AddEmailAddress";
import EditGroup from "../../components/EmailAddressBook/EditGroup";
import { checkJapanese, getToken, validateCSVData, downloadCsv } from "../../lib";
import config from "../../config/config";
import NotificationSystem from "react-notification-system";
import { FormattedMessage, injectIntl } from "react-intl";
import Papa from 'papaparse';

class EmailAddressBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openEmailModal: false,
      isEdit: false,
      selectedAddress: {},
      selectedGroup: {},
      openGroupModal: false,
      isCSVImportInProgress: false,
      sortBy: null,
      selectedSortMethods: {
        name: '',
        email: '',
        role: '',
        group: ''
      }
    };

    this.nameSortMethods = ['numerical', 'alphabetical', 'japanese-syllabary'];
    this.emailSortMethods = ['numerical', 'alphabetical'];
    this.roleSortMethods = ['host', 'participant'];
  }

  componentDidMount() {
    console.log("Component mounted");
    this.fetchGroups();
    this.fetchAddressBook();
  }

  fetchAddressBook = () => {
    const token = getToken();
    this.props.fetchEmailAddressBook(token);
  };

  fetchGroups = () => {
    const token = getToken();
    this.props.fetchGroups(token);
  };

  handleEmailButton = () => {
    this.setState({
      openEmailModal: true,
      isEdit: false,
      selectedAddress: {},
    });
  };

  handleEditAddress = (address) => {
    this.setState(
      {
        isEdit: true,
        selectedAddress: address,
      },
      () => {
        this.setState({ openEmailModal: true });
      }
    );
  };

  handleEditGroup = () => {
    this.setState({
      openGroupModal: true,
      isEdit: false,
      selectedGroup: {},
    });
  };

  uploadCSV = (body) => {
    return fetch(`${config.URI}/api/v1/upload_csv`, {
      method: "POST",
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      },
      body
    }).then(res => res.json())
  }

  handleCSVImport = files => {
    if (files && files.length > 0) {
      Papa.parse(files[0], {
        header: true,
        encoding: 'Shift-JIS',
        complete: results => {
          const data = validateCSVData(results.data, this.props.emailAddressBook, checkJapanese());
          console.log(data);
          if (data.length > 0) {
            this.uploadCSV(JSON.stringify({ data })).then(res => {
              this.setState({ isCSVImportInProgress: false });
              this.fetchAddressBook()
              this.showNotification(<FormattedMessage id="emailAddressBook.importAddressBookSuccess"/>, "success")
            }).catch(error => {
              this.setState({ isCSVImportInProgress: false });
              this.showNotification(<FormattedMessage id="emailAddressBook.csvUploadError"/>, "error");
            });
          } else {
            this.setState({ isCSVImportInProgress: false });
            this.showNotification(<FormattedMessage id="emailAddressBook.csvUploadError"/>, "error");
          }
        },
      });
    } else {
      console.log("Error while selecting the csv file.");
    }
  }

  handleSearch = (e) => {
    this.props.searchAddress(e.target.value);
  };

  showNotification = (message, level) => {
    const notification = this.refs.notificationSystem;
    notification.addNotification({
      message,
      level,
      position: 'tr',
      autoDismiss: 20
    })
  }

  handleCsvExport = () => {
    downloadCsv(checkJapanese());
  }

  getSortMethodsList = (type) => {
    return type === 'name'
      ? this.nameSortMethods
      : type === 'email'
        ? this.emailSortMethods
        : type === 'role'
          ? this.roleSortMethods
          : null;
  }

  handleSort = (type) => {
    const selectedSortMethods = this.state.selectedSortMethods;
    const list = this.getSortMethodsList(type);
    if(list) {
      const selectedIndex = list.findIndex(e => e === selectedSortMethods[type]);
      selectedSortMethods[type] = (selectedIndex === -1 || selectedIndex >= list.length - 1) ? list[0] : list[selectedIndex + 1];
      this.setState({ selectedSortMethods }, () => {
        this.props.sortAddressBook(selectedSortMethods[type], type === 'email' ? 'email_address' : type,);
      });
    }
  }

  render() {
    return (
      <Paper style={{ borderRight: "2px solid #e3e3e3", padding: "10px" }}>
        <NotificationSystem ref="notificationSystem" />
        {this.state.openEmailModal && (
          <AddEmailAddress
            open={this.state.openEmailModal}
            isEdit={this.state.isEdit}
            groups={this.props.groups}
            selectedAddress={this.state.selectedAddress}
            emailAddressBook={this.props.emailAddressBook}
            showNotification={this.showNotification}
            onSuccess={() => {
              this.fetchAddressBook();
              this.fetchGroups();
              this.setState({
                isEdit: false,
                selectedAddress: {},
                openEmailModal: false,
              });
            }}
            handleClose={() => {
              this.setState({ openEmailModal: false });
            }}
          />
        )}
        {this.state.openGroupModal && (
          <EditGroup
            open={this.state.openGroupModal}
            handleClose={() => this.setState({ openGroupModal: false })}
            groups={this.props.groups}
            emailAddressBook={this.props.emailAddressBook}
            onGroupUpdate={() => {
              this.fetchGroups();
              this.fetchAddressBook();
            }}
          />
        )}
        <ActionButtons
          handleAddEmail={this.handleEmailButton}
          handleEditGroup={this.handleEditGroup}
          handleFiles={this.handleCSVImport}
          onSearch={this.handleSearch}
          showLoader={this.state.isCSVImportInProgress}
          handleCsvExport={this.handleCsvExport}
        />
        <EmailAddressBookTable
          {...this.props}
          editAddress={this.handleEditAddress}
          sortAddress={this.handleSort}
        />
      </Paper>
    );
  }
}

export default injectIntl(EmailAddressBook);



// WEBPACK FOOTER //
// src/routes/EmailAddressBook/EmailAddressBook.js